import React from 'react';
import { motion } from 'framer-motion';
interface GlowOrbsProps {
  className?: string;
  /** Number of orbs */
  count?: number;
}
/**
 * Large floating glow orbs drifting slowly across the section. Massive
 * blur makes them feel atmospheric, not literal. Perfect for moody,
 * dramatic moments — history sections, brand statements, vision pages.
 */
export function GlowOrbs({
  className = '',
  count = 5
}: GlowOrbsProps) {
  const orbs = Array.from({
    length: count
  }).map((_, i) => {
    const colors = ['rgba(26,143,212,0.35)', 'rgba(122, 196, 240, 0.25)', 'rgba(10, 79, 122, 0.4)' // deep blue
    ];
    return {
      i,
      size: 320 + Math.random() * 360,
      x: Math.random() * 100,
      y: Math.random() * 100,
      dx: (Math.random() - 0.5) * 30,
      dy: (Math.random() - 0.5) * 30,
      dur: 16 + Math.random() * 14,
      color: colors[i % colors.length],
      delay: Math.random() * 5
    };
  });
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-210">
      {orbs.map(o => <motion.div key={o.i} className="absolute rounded-full" style={{
      width: o.size,
      height: o.size,
      left: `${o.x}%`,
      top: `${o.y}%`,
      marginLeft: -o.size / 2,
      marginTop: -o.size / 2,
      background: `radial-gradient(circle, ${o.color} 0%, transparent 70%)`,
      filter: 'blur(40px)'
    }} animate={{
      x: [0, o.dx, -o.dx * 0.6, 0],
      y: [0, o.dy, -o.dy * 0.7, 0],
      scale: [1, 1.15, 0.9, 1],
      opacity: [0.4, 0.8, 0.5, 0.4]
    }} transition={{
      duration: o.dur,
      repeat: Infinity,
      delay: o.delay,
      ease: 'easeInOut'
    }} data-id="element-211" />)}
    </div>;
}